import { Component, OnInit } from '@angular/core';
import { item } from 'src/app/m/item';
import { session } from 'src/app/m/session';

import { ItemService } from '../../s/item.service';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.css']
})
export class ItemComponent implements OnInit {

counter:number;
items: session[];
editstate: boolean = false;
itemtoedit: session;


  constructor(private ItemService:ItemService) { 

  }

  ngOnInit(): void {
    this.ItemService.getItem().subscribe(items => {
      this.items = items;
      this.counter = items.length;
    });
  }

  delitem(event,session:item){
    this.ItemService.delitems(session);
  }
  edititem(event,session:item){
    this.editstate = true;
    this.itemtoedit = session;

  }

  clearstate(){
    this.editstate = false;
    this.itemtoedit = null;
  }


}
